import Modal from 'shared/components/modal';
import { unpublishEpisode } from 'resources/episode';

function unpublish(episodeData) {
  Modal.present({
    title: 'Are you sure?',
    dialog: 'Are you sure you want to unpublish this episode?',
    actions: [
      { name: 'Cancel', value: false, variant: 'tertiary' },
      { name: 'Unpublish', value: true, variant: 'primary', intent: 'danger' },
    ],
  }).then(isConfirmed => {
    if (isConfirmed) {
      unpublishEpisode(episodeData);
    }
  });
}

export default unpublish;
